import { html } from 'lit-html'
import { until } from 'lit-html/directives/until'
import { cutlassEvent } from '@polleverywhere/cutlass'
import { installParticipateApp, isOkToShowInstallAppCTA } from './pwa'
import { url } from '@polleverywhere/core/lib/util'

import '@polleverywhere/pe-button'
import './style.scss'
import openWindow from '../../../util/open_window'
import { becomePresenterBanner, isOkToShowBecomePresenterCta } from './become-presenter-cta'

function slugify (text) {
  return text
    .toString()
    .normalize('NFD')
    .toLowerCase()
    .trim()
    .replace(/\s+/g, '-')
    .replace(/[^\w-]+/g, '')
    .replace(/--+/g, '-')
}

function dynamicBanner (el, config, state) {
  const { body, cta, url } = config

  return html`<div class="pollev-home__banner">
    <p>${body}</p>
    <pe-button @click=${() => {
      cutlassEvent(el, `${slugify(cta)}`)
      openWindow(url, state)
    }} label=${cta}></pe-button>
  </div>`
}

function pwaBanner (el) {
  return html`<div class="pollev-home__banner pollev-home__banner--pwa">
    <p>Poll Everywhere Participate -<br>the easiest way to respond to activities</p>
    <pe-button @click=${() => installParticipateApp('home')} label="Install now" theme=white></pe-button>
  </div>`
}

export function pollevBanner (el, state) {
  const templatePromise = new Promise((resolve) => {
    Backbone.ajax({ url: url('/api/pollev_banner') })
      .then((data) => {
        if (data?.body) {
          resolve(dynamicBanner(el, data, state))
        } else if (isOkToShowBecomePresenterCta(state)) {
          resolve(becomePresenterBanner(el, state))
        } else if (isOkToShowInstallAppCTA()) {
          resolve(pwaBanner())
        } else {
          resolve('')
        }
      })
  })
  return until(templatePromise, '')
}
